'use strict';

window.jQuery = window.$ = require('jquery');
require('sticky-kit/dist/sticky-kit.min');
window.jRes = require('./thirdParty/jRes').init();
var processInclude = require('@sfra/util');

$(document).ready(function () {
    processInclude(require('./polyfills')); // IE11 POLYFILLS

    processInclude(require('./components/bbwTabs'));
    processInclude(require('@sfra/components/cookie'));
    processInclude(require('./components/consentTracking'));
    processInclude(require('./components/bbwQtySelector'));
    processInclude(require('@sfra/components/footer'));
    processInclude(require('./components/miniCart'));
    processInclude(require('@plugin_wishlists/components/miniCart'));
    processInclude(require('@sfra/components/collapsibleItem'));
    processInclude(require('./components/search'));
    processInclude(require('./components/clientSideValidation'));
    processInclude(require('./components/countrySelector'));
    processInclude(require('./components/toolTip'));
    processInclude(require('./components/promotionModal'));

    processInclude(require('./sliders'));
    processInclude(require('./components/menu'));
    processInclude(require('./components/bbwTooltip'));
    processInclude(require('./components/bbwPopover'));
    processInclude(require('./components/addToBagModal'));
    processInclude(require('./components/maskPassword'));
    processInclude(require('./components/regexForms'));
    processInclude(require('./components/disableButtonEditProfile'));
    processInclude(require('./components/emailSubscribe'));
    processInclude(require('./components/expressCheckout'));

    processInclude(require('./util/inputFormatting'));
    processInclude(require('./util/dynamicHeight'));
    processInclude(require('./util/scrollAnchors'));
    processInclude(require('./components/sticky'));
    processInclude(require('./components/masks'));
    processInclude(require('./components/mutables/mutablesCore'));
    processInclude(require('./components/lightBox'));
    processInclude(require('./components/ratingsAndReviews'));
    processInclude(require('./components/zenDesk'));
    processInclude(require('./components/stickyHeader'));
    processInclude(require('./shoppableContent/shoppableContent'));
    processInclude(require('./components/categorySlider'));
    processInclude(require('./components/filterEinsteinCarousel'));
});

require('./util/jQueryPlugins');
require('./thirdParty/bootstrap');
require('./components/spinner');
require('./thirdParty/slick');

/*
 * IE11 POLYFILLS
 */
require('core-js/modules/es6.array.find');
require('url-polyfill');
